{
  "orgSlug": "aslase",
  "name": "Aslase",
  "logo": "/brand/aslase-logo.svg",
  "logoClass": "h-7 w-auto sm:h-8",
  "favicon": "/brand/aslase-logo.svg",
  "themeColor": "#00022f",
  "fontsHref": "https://fonts.googleapis.com/css2?family=Instrument+Sans:wght@500;600;700&family=Inter:wght@400;500;600&family=IBM+Plex+Sans+Arabic:wght@400;500;600&family=Cairo:wght@600;700&display=swap"
}
